module.exports = __webpack_public_path__ + "resource/img/placeholder.1632e46a.png";